import { memo } from "react";
import PropTypes from "prop-types";
import { paymentTypeShape } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import PaymentModesTooltip from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltip";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import "./PaymentDescriptionTerms.scss";

const PaymentDescriptionTerms = ({ availablePaymentTerms = [], availablePaymentMethods = [] }) => {
	return availablePaymentTerms.length > 1 ? (
		<div className="payment-description-terms" data-testid="payment-description-terms">
			<div className="payment-description-terms__label">
				<FormattedMessage id="payment.terms.description.label" />
			</div>

			{availablePaymentTerms?.map(availablePaymentTerm => {
				if (availablePaymentTerm !== 1) {
					return (
						<div className="payment-description-terms__item">
							{availablePaymentTerm}x
						</div>
					);
				}
				return null;
			})}

			<FloatingButton
				position="bottom"
				floatingContent={<PaymentModesTooltip paymentModes={availablePaymentMethods} />}
				referenceComponent={<IconInfo width={12} height={12} />}
			/>
		</div>
	) : null;
};

PaymentDescriptionTerms.propTypes = {
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
};
export default memo(PaymentDescriptionTerms);
